import request from '@utils/request'

export const state = {}

export const mutations = {}

export const actions = {
  /*
   * 取得單一項目
   * */
  fetchItem({ commit, getters }, { contentType, alias}) {
    return request
      .get(`/iot/${ contentType }/${ alias }`)
      // .then((response) => response.items)
  },
  /*
   * 搜尋類型
   * */
  fetchList({ commit }, { contentAlias, params }) {
    return request
      .post(`/iot/${ contentAlias }/search`, params)
      .then(({ items, featured = [], pagination }) => {
        return {
          items,
          featured,
          pagination
        }
      })
  },
  // /*
  // * 取得項目
  // * */
  // fetchItem({ commit }, { postType, itemAlias }) {
  //   return request
  //     .post(`/article/item/${itemAlias}`, {
  //       postType
  //     },{
  //       params: {
  //         postType
  //       }
  //     })
  // },
}
